// extracted by mini-css-extract-plugin
export default {"conference_section":"style_conference_section__JRDW5","title":"style_title__F7rTd","date":"style_date__Jq52f","content":"style_content__iSiHn"};